<div class="close-wrapper">
	<button mat-mini-fab type="button" (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<div class="lightbox-container">
	<div class="lightbox-inner-container"></div>
	<!-- <mat-progress-spinner *ngIf="!loaded"></mat-progress-spinner> -->
	<mat-progress-spinner mode="indeterminate" color="primary" *ngIf="!loaded"></mat-progress-spinner>
</div>
